module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Suessweine.4930a4c7.svg";